import React from "react"
import { Link } from "@StarberryUtils";
import { graphql } from 'gatsby'
import { Button, Container, Row, Form } from 'react-bootstrap';
import HTMLReactParser from 'html-react-parser';
import SEO from "../components/seo"

import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";
import StickyFooter from "../components/Footer/StickyFooter";
import AreaGuideSidebar from "../components/Sidebar/AreaGuideSidebar";
import Modules from '../components/modules';
import AreaGuideBanner from "../components/Home/Banner/AreaGuideBanner";
import AreaGuideStaticContact from "../components/Home/ContactUs/AreaGuideStaticContact";
import FeaturedProperties from "../components/Home/Properties/FeaturedProperties";
import Reviews from "../components/Home/Reviews/Reviews";
import OtherAreaGuides from "../components/collections/OtherAreaGuides";
import Map from "../components/map/google/single"
import NewsLetter from "../components/Home/NewsLetter/NewsLetter";
import Breadcrumb from "../components/Home/Breadcrumb/Breadcrumb";
import FooterBlock from "../components/Home/ContactUs/Contact";




import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/scss/bootstrap.scss';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../scss/bootstrap-overrides.scss";
import "../scss/grunticon.scss";
import "../scss/global.scss";
import "../scss/custom.scss";
import "./scss/area-guide-template.scss"

const AreaTemplate = (props) => {

	const [state, setState] = React.useState({
		showMenu: false
	})

	const handlerClick = () => {
		setState({ ...state, showMenu: !state.showMenu })
	}
	const Open_hours =props.data.glstrapi?.globalModule?.Opening_Hours;
	const GQLPage = props.data.glstrapi?.areaGuide;
	const ArticlePage = props.data.glstrapi?.article;
	const Site = props.data.glstrapi?.siteConfig;
	let reviewImage = { url: "https://ggfx-dachare.s3.eu-west-2.amazonaws.com/i.dev/todd_kent_178j8t_Jr_Nlc_unsplash_1_ad1a0c26f2.png" };
	
	let language = typeof window !== 'undefined' ? localStorage.getItem('language') : null
	return (
		<div className="homepage page-areaguide-details-wrap">
			<SEO title={`Living in ${GQLPage.Title} | ${GQLPage.Title} Area Guide`} description={GQLPage.Meta_Description ? GQLPage.Meta_Description : `Here is the insight about the in and around of ${GQLPage.Title} by Dacha Real Estate, which will help you to decide about property investment in ${GQLPage.Title}, Dubai.  `} location={props.location}/>

			<div className={`${state.showMenu ? "open-search-block" : "area-guide-detail"} ${language === 'Russian' ? "russian-page" : ""}`}>
				<Header showMenu={state.showMenu} handlerClick={handlerClick} fixed={true} />
				<Breadcrumb data={''} tag={`detail-page`} name={GQLPage.Title} category={`Area Guide`} />
				<AreaGuideBanner id={GQLPage.id} page={GQLPage} name={GQLPage.Title} url={GQLPage.URL} title={GQLPage.Header_Title} content={GQLPage.Header_Content} image={GQLPage.Banner_Image} info={GQLPage.Header_Call_Info} cta_1={GQLPage.Header_CTA_1_Label} cta_2={GQLPage.Header_CTA_2_Label} cta_1_link={GQLPage.Header_CTA_1_Link} cta_2_link={GQLPage.Header_CTA_2_Link} video={GQLPage.Video_URL} />
				<Container className={`static-content-landing  ${GQLPage.Banner_Image === null ? 'no-banner' : ''}`}>
					<div className="container">
					<Row>
						<div className="col-xl-8 col-md-12 plain-content area-guide-content">
							{GQLPage.Content &&
								<>
									{HTMLReactParser(GQLPage.Content.replace(/<br\s*\/?>/gi, ''))}
								</>
							}
						</div> 
						<div className="col-xl-4 col-md-12 areaside">
							<AreaGuideSidebar content={GQLPage.Sidebar_Content} peoples={GQLPage.Sidebar_People} site={Site} open_hours={Open_hours}/>
						</div>
					</Row>
					</div>
				</Container>
				{GQLPage.Latitude ?
					<Map lat={GQLPage.Latitude ? parseFloat(GQLPage.Latitude) : ''} lng={GQLPage.Longtitude ? parseFloat(GQLPage.Longtitude) : ''} height={"600px"} zoom={12} OfficeName={GQLPage.Title} /> : ''}
				    <FeaturedProperties place={GQLPage.Title} searchType="sales"/>
				{
					ArticlePage.Modules && ArticlePage.Modules.map((module, i) => {
						return (
							<>
								{
									module.Reviews_Background_Image &&
									<Reviews image={module.Reviews_Background_Image} imagetransforms={ArticlePage?.imagetransforms} />
								}
							</>
						)


					})
				}
				{/* <Reviews image={reviewImage} /> */}
				<OtherAreaGuides id={GQLPage.id} />
				{/* <AreaGuideStaticContact /> */}
				{GQLPage?.Footer_Block && 
					<FooterBlock { ...GQLPage?.Footer_Block} id={GQLPage?.id} imagename="area-guides.Modules.Footer_Block.Image.tile_image" />
				}
				{/* <NewsLetter /> */}
				<Footer />
				{/* <StickyFooter /> */}
			</div>


		</div>
	)
}

export default AreaTemplate;

export const pageQuery = graphql`
  query AreaQuery($id: ID!) {
    glstrapi {
		globalModule {
		  Opening_Hours
	    }
		areaGuide(id: $id, publicationState: LIVE) {
		  Banner_Image {
			alternativeText
			url
		  }
		  Content
		  Header_CTA_1_Label
		  Header_CTA_1_Link {
			URL
			Label
		  }
		  Header_CTA_2_Label
		  Header_CTA_2_Link {
			Label
			URL
		  }
		  Header_Call_Info
		  Header_Title
		  Header_Content
		  Latitude
		  Longtitude
		  Meta_Description
		  ggfx_results {
            id
            src_cftle
            src_url
            transforms
            updatedAt
            createdAt
            _id
    }
		  Meta_Title
		  Publish
		  Tile_Image {
			alternativeText
			url
		  }
		  Title
		  URL
		  Video_URL
		  id
		  createdAt
		  published_at
		  Sidebar_Content
		  Sidebar_People {
			URL
			Tile_Image {
			  url
			}
			Name
			Phone
			Designation
		  }
		  imagetransforms
		  Footer_Block {
                    FooterBlockTitle: Title
                    Content
                    CTA_1_Label
                    CTA_1_Action
                    CTA_1_Link {
                    id
                    URL
                    }
                    CTA_2_Label
                    CTA_2_Action
                    CTA_2_Link {
                    id
                    URL
                    }
                    Image {
                    url
                    alternativeText
                    }
            }
		}
		article(id: "60a4bf70123ae87ffba01add") {
			Modules {
				... on GLSTRAPI_ComponentModuleGoogleReviews {
					id
					Reviews_Background_Image {
					  alternativeText  
					  url
					}
				  }
			}
			imagetransforms
		}
		siteConfig {
			Address
			Email
			Phone
			Available_Timings
		  }
		
	  }   
  }
`